import type { ComponentPropsWithoutRef } from 'react';

export type LinkProps = ComponentPropsWithoutRef<'a'> & {
  href: string; // explicitly marked as required
};

const IS_EXTERNAL_OR_SCHEME = /^(?:[a-z][a-z0-9+.-]*:|#|\/)/i;

const Link = ({ href, children, target, rel, ...props }: LinkProps) => {
  const finalHref = IS_EXTERNAL_OR_SCHEME.test(href) ? href : `/${href}`;
  const computedRel =
    target === '_blank'
      ? [
          ...new Set([...(rel?.split(' ') || []), 'noopener', 'noreferrer']),
        ].join(' ')
      : rel;

  return (
    <a href={finalHref} target={target} rel={computedRel} {...props}>
      {children}
    </a>
  );
};

export { Link };
